<mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
<app-data-table
                [actions]="actions"
                [columns]="columns"
                [dataSource]="dsResponses"
                [extraParams]="extraParams"
                [overFlow]="true"
                [filterDisplay]="true"
                [minFilter]="0"
                [flexAction]="5"
                [flexColumn]="90"
                [fontSizeCell]="'0.9em'"
                [pageSize]="10"
                [pageSizesList]="[5,10,25]"
                [placeHolderFilter]="'Rechercher des demandes sur une référence ou nom/prénom demandeur'"
                [toolTipFilter]="'Rechercher de demandes : sur une référence ou un nom/prénom demandeur puis [ENTER]'"
                [refreshButton]="false"
                [refreshIcone]="true"
                [showFirstLastButtons]="true"
                [showLoader]="true"
                [loaderMask]="true"
></app-data-table>

<!--[autoLoad]="false"-->
